import React from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { GetDuration } from '../methods';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';

import { editContributionEnd as editContributionEndAction } from './contributionActions';
const getDuration = new GetDuration();

class EditableContributionField extends React.Component {
  constructor() {
    super();
    this.state = {
      editing: false
    };
  }

  handleEditValidation = (start, missionId, contributionId) => {
    this.setState({ editing: false });

    const newDurationString = document
      .getElementById('newDurationId')
      .value.split('');

    const editedEndDate = getDuration.getNewEndDateAfterEditingContribution(
      newDurationString,
      start
    );

    this.props.editContributionEndAction(
      editedEndDate,
      missionId,
      contributionId
    );
  };

  handleEditDuration = e => {
    this.setState({ editing: true });
  };

  renderDurationField = (
    start,
    end,
    contributionMissionId,
    contributionId,
    roleLevel,
    state
  ) => {
    const editableTime = getDuration.getEditableDuration(start, end);
    const missionId = contributionMissionId;

    if (!this.state.editing) {
      return (
        <div
          style={{
            display: 'flex'
            //justifyContent: 'flex-start',
            //flexDirection: 'column'
          }}
        >
          <p>{getDuration.getOneDuration(start, end)}</p>
          {roleLevel > 0 &&
            state === 'pending_review' && (
              <button
                style={{ margin: 10 }}
                onClick={event => this.handleEditDuration(event)}
              >
                <EditIcon style={{ color: 'orange', fontSize: 20 }} />
              </button>
            )}
        </div>
      );
    }
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start'
          // flexDirection: 'column'
        }}
      >
        <form
          onSubmit={event =>
            this.handleEditValidation(start, missionId, contributionId)
          }
        >
          <TextField
            id="newDurationId"
            label={false}
            //type="time"
            defaultValue={editableTime}
            required
            // defaultValue="2017-05-24T10:30"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 60,
              pattern: '([01]?[0-9]|2[0-3]):[0-5][0-9]'
            }}
          />
          {roleLevel > 0 && (
            <button style={{ margin: 10 }} type="submit">
              <DoneIcon style={{ color: 'green', fontSize: 20 }} />
            </button>
          )}
        </form>
      </div>
    );
  };

  render() {
    const { contribution, translate, roleLevel } = this.props;
    const {
      start,
      end,
      id: contributionId,
      missionId: contributionMissionId,
      state
    } = contribution;

    return !start
      ? translate('contributions.not_started')
      : !end
        ? translate('contributions.not_finished')
        : this.renderDurationField(
            start,
            end,
            contributionMissionId,
            contributionId,
            roleLevel,
            state
          );
    // : getDuration.getOneDuration(start, end);
  }
}

export default connect(
  null,
  { editContributionEndAction }
)(EditableContributionField);



// WEBPACK FOOTER //
// ./src/contributions/EditableContributionField.js